export default {
  header: 'Choisir un menu',
  open_now: 'Ouvert maintenant',
};
